import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { App } from './app/app';
import { removeAuthErrorHashFromCurrentUrl } from './app/core/auth/auth-url.utils';

removeAuthErrorHashFromCurrentUrl();

bootstrapApplication(App, appConfig)
  .catch((err) => console.error(err));
